import { ReactNode } from "react"
import SelectField from "./SelectFields"

export default function ConditionalSelectField({
    label,
    children,
    showSelect,
}: {
    label: string,
    children: ReactNode,
    showSelect: boolean,
}) {

    return (
        <>
        {showSelect ? (
            <>{children}</>
        ) : (
            <SelectField 
                label={label}
                id=''
                name=''
                options={[]}
                value={null}
                isRequired={false}
                handleChange={() => {}}
                isCreatable
                isMulti
            />
        )}
        </>
    )
}